import React, { useContext, useEffect, useRef, useState } from 'react';

import { DefaultBsComponent } from '../../types/module';
import { classNames } from '../../utils/style';
import { AccordionContext } from './AccordionContext';

export interface AccordionContentType extends DefaultBsComponent {
  animOnClose?: boolean;
  animOnOpen?: boolean;
}

export const AccordionContent = ({
  animOnClose = false,
  animOnOpen = true,
  className,
  as: Component = 'div',
  ...props
}: AccordionContentType) => {
  const ref = useRef<any>(null);
  const [height, setHeight] = useState(0);
  const { open, answer } = useContext(AccordionContext);
  useEffect(() => {
    setHeight(ref?.current?.clientHeight);
  }, []);

  return (
    <div
      className={classNames('relative', open ? 'fadeIn' : 'fadeOut', className)}
    >
      <Component
        {...props}
        className={classNames(
          'AccordionContent',
          animOnOpen && open && 'ease-bounce animate-fade-in',
          animOnClose && !open && 'ease-bounce animate-fade-out-200',
          'overflow-hidden h-auto max-h-[0px] transition-all duration-[600ms]',
        )}
        style={{ maxHeight: open ? `${height}px` : null }}
      >
        <div ref={ref}>
          {answer}
        </div>
      </Component>
    </div>
  );
};
